'use strict';

module.exports = footnoteReference;

function footnoteReference(node) {
  return '[^' + node.identifier + ']';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/footnote-reference.js
// module id = 296
// module chunks = 96961042003272 139266963665775